import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { Fragment } from '@wordpress/element';
import { Icon } from '@wordpress/components';
import { __, _n, sprintf } from '@wordpress/i18n';

function DownloadableBlockInfo(_ref) {
  var description = _ref.description,
      activeInstalls = _ref.activeInstalls,
      humanizedUpdated = _ref.humanizedUpdated;
  return createElement(Fragment, null, createElement("p", {
    className: "block-directory-downloadable-block-info__content"
  }, description), createElement("div", {
    className: "block-directory-downloadable-block-info__row"
  }, createElement("div", {
    className: "block-directory-downloadable-block-info__column"
  }, createElement(Icon, {
    icon: "chart-line"
  }), sprintf(_n('%d active installation', '%d active installations', activeInstalls), activeInstalls)), createElement("div", {
    className: "block-directory-downloadable-block-info__column"
  }, createElement(Icon, {
    icon: "update"
  }), createElement("span", {
    "aria-label": sprintf(__('Updated %s'), humanizedUpdated)
  }, humanizedUpdated))));
}

export default DownloadableBlockInfo;
//# sourceMappingURL=index.js.map